import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/program/program-avatar.jpg'
import _imports_1 from '@/assets/images/program/program-poster.jpg'
import _imports_2 from '@/assets/images/program/program-opening.jpg'
import _imports_3 from '@/assets/images/program/program-whiteboard.jpg'
import _imports_4 from '@/assets/images/program/program-photo.jpg'
import _imports_5 from '@/assets/images/program/program-rock.jpg'
import _imports_6 from '@/assets/images/program/program-radio.jpg'
import _imports_7 from '@/assets/images/program/program-experience.jpg'
import _imports_8 from '@/assets/images/program/program-research.jpg'
import _imports_9 from '@/assets/images/program/program-ending.jpg'
import _imports_10 from '@/assets/images/program/program-ddp.jpg'
import _imports_11 from '@/assets/images/info-event.jpg'


const _withScopeId = n => (_pushScopeId("data-v-24938078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program-wrap" }
const _hoisted_2 = {
  class: "program-box",
  id: "avatar_dressing_room"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "program-inner" }
const _hoisted_5 = { class: "program-title" }
const _hoisted_6 = { class: "program-time" }
const _hoisted_7 = { class: "program-place" }
const _hoisted_8 = { class: "program-h" }
const _hoisted_9 = {
  class: "program-box",
  id: "poster_exhibition"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "program-inner" }
const _hoisted_12 = { class: "program-title" }
const _hoisted_13 = { class: "program-time" }
const _hoisted_14 = { class: "program-place" }
const _hoisted_15 = { class: "program-h" }
const _hoisted_16 = {
  class: "program-box",
  id: "opening"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "program-inner" }
const _hoisted_19 = { class: "program-title" }
const _hoisted_20 = { class: "program-time day-1" }
const _hoisted_21 = { class: "program-place" }
const _hoisted_22 = { class: "program-h" }
const _hoisted_23 = {
  class: "program-box",
  id: "whiteboard_1"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "program-inner" }
const _hoisted_26 = { class: "program-title" }
const _hoisted_27 = { class: "program-time day-1" }
const _hoisted_28 = { class: "program-place" }
const _hoisted_29 = { class: "program-h" }
const _hoisted_30 = {
  class: "program-box",
  id: "group_photo"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "program-inner" }
const _hoisted_33 = { class: "program-title" }
const _hoisted_34 = { class: "program-time day-1" }
const _hoisted_35 = { class: "program-place" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { class: "program-h" }
const _hoisted_38 = {
  class: "program-box",
  id: "jmof_rock_festival"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "program-inner" }
const _hoisted_41 = { class: "program-title" }
const _hoisted_42 = { class: "program-time day-1" }
const _hoisted_43 = { class: "program-place" }
const _hoisted_44 = { class: "program-h" }
const _hoisted_45 = {
  class: "program-box",
  id: "whiteboard_2"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_47 = { class: "program-inner" }
const _hoisted_48 = { class: "program-title" }
const _hoisted_49 = { class: "program-time day-1" }
const _hoisted_50 = { class: "program-place" }
const _hoisted_51 = { class: "program-h" }
const _hoisted_52 = {
  class: "program-box",
  id: "radio_exercises"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_54 = { class: "program-inner" }
const _hoisted_55 = { class: "program-title" }
const _hoisted_56 = { class: "program-time day-2" }
const _hoisted_57 = { class: "program-place" }
const _hoisted_58 = { class: "program-h" }
const _hoisted_59 = {
  class: "program-box",
  id: "vr_experience"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_61 = { class: "program-inner" }
const _hoisted_62 = { class: "program-title" }
const _hoisted_63 = { class: "program-time day-2" }
const _hoisted_64 = {
  class: "program-box",
  id: "furries_research"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_66 = { class: "program-inner" }
const _hoisted_67 = { class: "program-title" }
const _hoisted_68 = { class: "program-time day-2" }
const _hoisted_69 = { class: "program-place" }
const _hoisted_70 = { class: "program-h" }
const _hoisted_71 = {
  class: "program-box",
  id: "whiteboard_3"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_73 = { class: "program-inner" }
const _hoisted_74 = { class: "program-title" }
const _hoisted_75 = { class: "program-time day-2" }
const _hoisted_76 = { class: "program-place" }
const _hoisted_77 = { class: "program-h" }
const _hoisted_78 = {
  class: "program-box",
  id: "ending"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_80 = { class: "program-inner" }
const _hoisted_81 = { class: "program-title" }
const _hoisted_82 = { class: "program-time day-2" }
const _hoisted_83 = { class: "program-place" }
const _hoisted_84 = { class: "program-h" }
const _hoisted_85 = {
  class: "program-box",
  id: "dead_dog_party"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_87 = { class: "program-inner" }
const _hoisted_88 = { class: "program-title" }
const _hoisted_89 = { class: "program-time day-2" }
const _hoisted_90 = { class: "program-h" }
const _hoisted_91 = {
  class: "program-box wide",
  id: "participant_hosted"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_93 = { class: "program-inner" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = { class: "text-small" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-program" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'title')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'time')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'title')), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'time')), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'title')), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'time')), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_3', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'title')), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'time')), 1),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'title')), 1),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'time')), 1),
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'place')), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_1')) + " ", 1),
                  _hoisted_36,
                  _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_2')), 1)
                ]),
                _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_3')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_4')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'caution_1')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h3", _hoisted_41, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'title')), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'time')), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'caution_1')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'title')), 1),
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'time')), 1),
                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_51, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'title')), 1),
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'time')), 1),
                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_58, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'p_2')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'p_3')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("h3", _hoisted_62, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'title')), 1),
                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'time')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_10', 'caution_1')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'title')), 1),
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'time')), 1),
                _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_70, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_11', 'caution_1')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("h3", _hoisted_74, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'title')), 1),
                _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'time')), 1),
                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_77, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("h3", _hoisted_81, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'title')), 1),
                _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'time')), 1),
                _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_13', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("h4", _hoisted_84, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("h3", _hoisted_88, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'title')), 1),
                _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'time')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'p_1')), 1),
                _createElementVNode("h4", _hoisted_90, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'participation')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'p_2')), 1)
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-h')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-p_1')), 1),
                _hoisted_94,
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('info-p_2')), 1)
              ]),
              _createElementVNode("p", _hoisted_95, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-p_3')), 1),
                _hoisted_96,
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('info-p_4')), 1),
                _hoisted_97,
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('info-p_5')), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}